<template>
  <div class="portrait_fans">
    <div class="avatar-info">
      <img class="avatar" :src="avatar" v-if="avatar"/>
      <div style="width: 100%">
        <div class="flex-box">
          <div class="nickname">{{ fansObj.nickname }}</div>
          <el-button type="text" size="medium" style="padding: 0" icon="el-icon-refresh-right"
            @click="updateKolInfo">更新达人信息</el-button>
        </div>
        <div class="info">
          <span>快手号：{{ platformId }}</span>
          <span>作品数：{{ totalWork }}</span>
        </div>
        <div class="info">
          <span>粉丝总数：{{ fans }}</span>
          <span>带货能力：{{ salesRankUser }}
            <el-tooltip effect="dark" placement="top-start">
              <div slot="content" class="w-500">
                带货能力由高到低分为S、A、B、C、D五个等级。由当前达人连续30天内，在快手平台短视频、直播时长、商品销售量、销售额等数据加权计算得出。反映达人在快手平台的相对带货能力
              </div>
              <i class="el-icon-question hovers"></i>
            </el-tooltip>
          </span>
        </div>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="empty-area" v-if="!isfans && !isprovince && !isgender && !isstar">
      <div class="empty-img"></div>
      <div class="empty-font">暂无数据</div>
    </div>
    <!-- 粉丝趋势 -->
    <div class="chars-box" v-if="haveValue && isfans">
      <div class="title">粉丝趋势</div>
      <ve-histogram class="chart-canvas"
        :data="kFansChart"
        :settings="kFansChartSettings"
        :extend="kFansChartExtend"></ve-histogram>
      <!-- <div id="dFansChart" class="chart-canvas"></div> -->
    </div>
    <!-- 省份分布 -->
    <div class="chars-box" v-if="haveValue && isprovince">
      <div class="title">省份分布</div>
      <ve-bar class="chart-canvas"
        :data="kProvinceChart" 
        :settings="kProvinceChartsetting"
        :extend="kProvinceChartextent"></ve-bar>
      <!-- <div id="dProvinceChart" class="chart-canvas"></div> -->
    </div>
    <!-- 性别/年龄分布 -->
    <div class="chars-flex">
      <div class="chars-box" v-if="haveValue && isgender">
      <div class="title">性别分布</div>
      <ve-ring class="chart-canvas"
        :data="kGenderChart"
        :legend-visible="false"
        :settings="kGenderChartsetting"
        :extend="kGenderChartextent"></ve-ring>
      <!-- <div id="kGenderChart" class="chart-canvas"></div> -->
      </div>
      <!-- 星座分布 -->
      <div class="chars-box" v-if="haveValue && isstar">
        <div class="title">星座分布</div>
        <ve-bar class="chart-canvas"
          :data="kStarChart" 
          :extend="kStarChartExtend"></ve-bar>
        <!-- <div id="dAgeChart" class="chart-canvas"></div> -->
      </div>
    </div>
  </div>
</template>
<script>
import echartConf from "@/config/echartConf.js"
export default {
  name: "kuaishou_portrait",
  components:{},
  props: {
    fansObj: {
      luopan_id: 0,
      nickname: "",
    }
  },
  data() {
    this.kGenderChartsetting = {
      dataType: 'percent'
    }
    this.kFansChartSettings = {
      showLine: ['粉丝总数'],
      axisSite: { right: ['粉丝净增'] },
      yAxisName: ['粉丝总数', '粉丝净增']
    }
    this.kFansChartExtend = {
      color: echartConf.lineColor,
      tooltip : echartConf.tooltip,
      series: {
        barWidth: 16,
      }
    }
    this.kProvinceChartsetting = {
      xAxisType: ['percent'],
    }
    this.kStarChartExtend = {
      color: echartConf.multipleColor,
      tooltip : echartConf.tooltip,
      angleAxis: {
        type: 'category',
        data: []
      },
      radiusAxis: {},
      polar: {},
      series: {
        type: 'bar',
        data: [],
        coordinateSystem: 'polar',
        name: '星座',
      }
    }
    this.kProvinceChartextent = {
      color: echartConf.multipleColor,
      tooltip : echartConf.tooltip,
      series: {
        barWidth: 16
      }
    }
    this.kGenderChartextent = {
      color: echartConf.multipleColor
    }
    return {
      fans: "",
      totalWork: "",
      salesRankUser: "",
      avatar: "",
      platformId: "",
      haveValue: false,
      isfans: false,
      isprovince: false,
      isgender: false,
      isstar: false,
      kFansChart: {
        columns: ['日期', '粉丝总数', '粉丝净增'],
        rows: []
      },
      kProvinceChart: {
        columns: ['省份', ''],
        rows: []
      },
      kGenderChart: {
        columns: ['name', 'value'],
        rows: []
      },
      kStarChart: {},
      apiUrl: {
        getFansKsImg: "/home/getFansKsImg",
        redirectJavaApi: "/home/redirectJavaApi"
      }
    }
  },
  created() {},
  mounted() {
    this.getData();
    // this.fansFunc();
    // this.provinceFunc();
    // this.genderFunc([{"value": "0.4250","name": "男"},{"value": "0.5750","name": "女"}]);
    // this.starFunc();
  },
  methods: {
    fansFunc(res) {
      let key = res.fansKey;
      let value = res.fansAllNum;
      let value2 = res.fansIncrease;
      // let key = ["2020-01-28",
      //   "2020-01-29",
      //   "2020-01-30",
      //   "2020-01-31",
      //   "2020-02-01",
      //   "2020-02-02",
      //   "2020-02-03",
      //   "2020-02-04",
      //   "2020-02-05",
      //   "2020-02-06",
      //   "2020-02-07",
      //   "2020-02-08",
      //   "2020-02-09",
      //   "2020-02-10",
      //   "2020-02-11",
      //   "2020-02-12",
      //   "2020-02-13",
      //   "2020-02-14",
      //   "2020-02-15",
      //   "2020-02-16",
      //   "2020-02-17",
      //   "2020-02-18",
      //   "2020-02-19",
      //   "2020-02-20",
      //   "2020-02-21",
      //   "2020-02-22",
      //   "2020-02-23",
      //   "2020-02-24",
      //   "2020-02-25",
      //   "2020-02-26"
      // ];
      // let value = [478000,
      //   485000,
      //   493000,
      //   501000,
      //   509000,
      //   516000,
      //   523000,
      //   531000,
      //   540000,
      //   573000,
      //   608000,
      //   668000,
      //   729000,
      //   771000,
      //   814000,
      //   854000,
      //   885000,
      //   926000,
      //   971000,
      //   1031000,
      //   1075000,
      //   1112000,
      //   1146000,
      //   1176000,
      //   1196000,
      //   1225000,
      //   1252000,
      //   1261000,
      //   1271000,
      //   1279000
      // ];
      // let value2 = [
      //   5000,
      //   7000,
      //   8000,
      //   8000,
      //   8000,
      //   7000,
      //   7000,
      //   8000,
      //   9000,
      //   33000,
      //   35000,
      //   60000,
      //   61000,
      //   42000,
      //   43000,
      //   40000,
      //   31000,
      //   41000,
      //   45000,
      //   60000,
      //   44000,
      //   37000,
      //   34000,
      //   30000,
      //   20000,
      //   29000,
      //   27000,
      //   9000,
      //   10000,
      //   8000
      // ];
      let rowArr = [];
      for(let i = 0; i < key.length; i++) {
        for (let j = 0; j < value.length; j++) {
          for (let k = 0; k < value2.length; k++) {
            let row = {}
            if (i === j && i === k) {
              row['日期'] = key[i];
              row['粉丝总数'] = value[j];
              row['粉丝净增'] = value2[k];
              rowArr.push(row);
            }
          }
        }
      }
      this.kFansChartSettings.min = [res.fansMin]
      this.kFansChartSettings.max = [res.fansMax]
      // this.kFansChartSettings.min = [478000]
      // this.kFansChartSettings.max = [1279000]
      this.kFansChart.rows = rowArr;
    },
    provinceFunc(res) {
      let key = res.provinceKey;
      let value = res.provinceValue;
      // let key = [
      //   " 山东",
      //   " 江苏",
      //   " 辽宁",
      //   "广西",
      //   " 河北",
      //   " 河南",
      //   " 天津",
      //   " 甘肃",
      //   " 山西",
      //   " 新疆博尔塔拉蒙古自治州"
      // ];
      // let value = [
      //   30.43,
      //   13.039999999999999,
      //   8.6999999999999993,
      //   4.3499999999999996,
      //   4.3499999999999996,
      //   4.3499999999999996,
      //   4.3499999999999996,
      //   4.3499999999999996,
      //   4.3499999999999996,
      //   4.3499999999999996
      // ];
      let rowArr = [];
      for(let i = 0; i < key.length; i++) {
        for (let j = 0; j < value.length; j++) {
          let row = {}
          if (i === j) {
            row['省份'] = key[i];
            row[''] = parseFloat(value[j]) / 100;
            rowArr.push(row);
          }
        }
      }
      this.kProvinceChart.rows = rowArr;
    },
    starFunc(res) {
      let key = res.zodiacKey;
      let value = res.zodiacValue;
      // let key = [
      //   "金牛座",
      //   "双子座",
      //   "射手座",
      //   "天蝎座",
      //   "处女座",
      //   "摩羯座",
      //   "白羊座"
      // ];
      // let value = [
      //   0.10000000000000001,
      //   0.20000000000000001,
      //   0.20000000000000001,
      //   0.20000000000000001,
      //   0.10000000000000001,
      //   0.10000000000000001,
      //   0.10000000000000001
      // ];
      this.kStarChartExtend.angleAxis.data = key;
      this.kStarChartExtend.series.data = value;
    },
    genderFunc(res) {
      this.kGenderChart.rows = res;
    },
    //粉丝分析
    getData() {
      let data = {
        id: this.fansObj.luopan_id
      }
      this
        .$http({
          method: "GET",
          url: this.apiUrl.getFansKsImg,
          params: data
        })
        .then(res => {
          if (res.code == 1) {
            this.haveValue = true;
            this.fans = res.data.fans
            this.avatar = res.data.avatar
            this.totalWork = res.data.totalWork
            this.salesRankUser = res.data.salesRankUser
            this.platformId = res.data.platformId
            // 粉丝趋势
            if(res.data.ksKolUserFansInc) {
              this.fansFunc(res.data.ksKolUserFansInc);
              this.isfans = true;
              // _this.kFansOption.xAxis.data = res.data.ksKolUserFansInc.fansKey
              // _this.kFansOption.yAxis[0].min = res.data.ksKolUserFansInc.fansMin
              // _this.kFansOption.yAxis[0].max = res.data.ksKolUserFansInc.fansMax
              // _this.kFansOption.series[0].data = res.data.ksKolUserFansInc.fansIncrease
              // _this.kFansOption.series[1].data = res.data.ksKolUserFansInc.fansAllNum
              // _this.chartArr[0].show = true
              // _this.kHaveValue = true
            }
            // 性别分布
            if(res.data.fansSex){
              this.genderFunc(res.data.fansSex);
              this.isgender = true;
              // _this.kGenderOption.series.data = res.data.fansSex
              // _this.chartArr[3].show = true
              // _this.kHaveValue = true
            }
            // 星座分布
            if(res.data.zodiacFans){
              this.starFunc(res.data.zodiacFans);
              this.isstar = true;
              // _this.kStarOption.angleAxis.data = res.data.zodiacFans.zodiacKey
              // _this.kStarOption.series.data = res.data.zodiacFans.zodiacValue
              // _this.chartArr[2].show = true
              // _this.kHaveValue = true
            }
            // 省份分布
            if(res.data.topTenProvinceFans){
              this.provinceFunc(res.data.topTenProvinceFans);
              this.isprovince = true;
              // _this.kProvinceOption.yAxis.data = res.data.topTenProvinceFans.provinceKey
              // _this.kProvinceOption.series.data = res.data.topTenProvinceFans.provinceValue
              // _this.chartArr[1].show = true
              // _this.cityShow = true
              // _this.kHaveValue = true
            }
          } else {
            this.haveValue = false
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 更新达人
    updateKolInfo(){
      let data = {
        request_api_info: '/kol/updateKsKol_post',
        id: this.fansObj.luopan_id,
      }
      this.$http({
        method: "GET",
        url: this.apiUrl.redirectJavaApi,
        params: data
      }).then(res => {
        if (res.code == 1) {
          this.$message.success('数据获取需要一定时间，可稍后再来查看数据。')
        }else{
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err);
      });
    },
    //过万处理
    million (value){
      let num;
      if(value > 9999){
        num = Number((value/10000).toFixed(2))+'w'
        return num;
      }
      return value;
    }
  }
}
</script>
<style scoped>
.portrait_fans {
  padding-top: 25px;
}
.flex-box,
.chars-flex,
.avatar-info {
  display: flex;
}
.flex-box {
  justify-content: space-between;
}
.info {
  font-size: 14px;
  color: #666;
  line-height: 28px;
  margin-bottom: 5px;
}
.info > span {
  display: inline-block;
  width: 150px;
  margin-right: 87px;
}
.chars-box {
  width: 100%;
}
.chars-flex .chars-box {
  width: 50%;
}
.chars-box .title {
  font-size: 20px;
  color: #252328;
  position: relative;
}
.chars-box .title::before {
  content: "";
  height: 20px;
  width: 3px;
  background-color: #6435E8;
  position: absolute;
  left: -20px;
  top: 4px;
}
.avatar {
  width: 100px;
  height: 100px;
  border-radius: 6px;
  margin-right: 16px;
}
.nickname {
  font-size: 14px;
  color: #333;
  line-height: 28px;
}
.chart-canvas {
  width: 100%;
  height: 300px;
}
.empty-area {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.empty-img {
  width: 100px;
  height: 74px;
  margin-top: 83px;
  background: url("../../assets/my/null.png") no-repeat center;
  background-size: cover;
}
.empty-font {
  font-size: 14px;
  color: #666;
  margin: 10px 0 0 0;
}
.w-500 {
  max-width: 500px;
}
</style>